<div class="hero-section">
  <div class="hero-content">
    <h1 class="hero-title">
      <span class="hero-title-line">Human Resource Management</span>
      <span class="hero-title-line hero-title-line--second">made <span class="hero-title-highlight">effortless</span>.</span>
    </h1>

    <p class="hero-description">
      A unified HR experience for hiring, onboarding, payroll, attendance, and employee performance.
      Fast, complete, and simple, built for modern teams.
    </p>

    <div class="hero-buttons">
      <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
      <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="hrApp"
  (goBack)="showRegister = false"
></app-register>
